module.exports = __webpack_public_path__ + "media/images/flags/16/Isle-of-Man-6704e0bf2ef6d9ddbbd6c7991c3153ba.png";